export default __webpack_public_path__ + "static/media/Heart@2x.961ce10e.png";